module.exports = __webpack_public_path__ + "images/content.b0a50350ab15c3f0ad3b4378b178707e.svg";